<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        &copy; 2023 - Escuela de vuelo
        <strong><a href="https://www.ba-flight.com/" target="_blank">BA FLIGHT</a></strong
        >.
      </p>
    </div>
  </footer>
</template>
